import { useMutation } from '@tanstack/react-query';

import { Groups } from '@app/client/resources';

export const useShowInviteData = () => {
    return useMutation((inviteCode: string) => Groups.callShowInvite({ inviteCode }));
};
